export default __webpack_public_path__ + "static/3-45eea8e673c9b694cad646f80652104d.jpg";